
import { useState } from 'react';
import { CTAModal } from './CTAModal';

export function FixedCTABar() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] py-3 px-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between gap-4">
          <div className="hidden sm:flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-full">
              <i className="ri-calendar-check-line text-xl text-orange-600"></i>
            </div>
            <div>
              <p className="text-sm font-bold text-gray-800">まずは無料で体験！</p>
              <p className="text-xs text-gray-500">お子様に合うか試してみませんか？</p>
            </div>
          </div>
          <button
            onClick={() => setIsModalOpen(true)}
            className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold text-base px-8 py-3.5 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap animate-pulse hover:animate-none"
          >
            <i className="ri-calendar-check-line mr-2"></i>
            無料体験を申し込む
          </button>
        </div>
      </div>

      <CTAModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        type="trial"
      />
    </>
  );
}
